import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApplicationStore, ApplicationStoreType } from '../store/application.store';
import { whenOrganizationAccessResolved } from './organization-access';
import { OrganizationPrivilege } from '../../shared/types/organization';
import { AppUrls } from '../../routing/app-urls';

export const privilegeGuard =
    (privilege: OrganizationPrivilege | OrganizationPrivilege[]): CanActivateFn =>
    () => {
        const applicationStore: ApplicationStoreType = inject(ApplicationStore);
        const router = inject(Router);

        const requiredPrivileges = Array.isArray(privilege) ? privilege : [privilege];

        const checkAccess = () => {
            if (requiredPrivileges.some((p) => applicationStore.hasPrivilege(p))) {
                return true;
            }
            const redirectUrl = requiredPrivileges.includes(OrganizationPrivilege.OrgAccess)
                ? AppUrls.noAccessUrl
                : AppUrls.hotelGptUrl;
            return router.createUrlTree(['/', redirectUrl]);
        };

        return whenOrganizationAccessResolved(checkAccess);
    };
